import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { connect } from "react-redux";

const select = ({ interactiveMap }) => ({
  fullscreen: interactiveMap.fullscreen
});

function MobileNav({ fullscreen }) {
  const [showDrawer, setShowDrawer] = useState(false);
  return (
    <Container hide={fullscreen}>
      <Tab onClick={() => setShowDrawer(true)} />
      {showDrawer && <Drawer handleClose={() => setShowDrawer(false)} />}
    </Container>
  );
}

export default connect(select)(MobileNav);

const Container = styled.div`
  position: fixed;
  z-index: 100;
  top: 1em;
  left: 0;
  display: ${({ hide }) => (hide ? "none" : "block")};
`;
const countries = ["thailand", "vietnam", "bali", "laos"];
function Drawer({ handleClose }) {
  return (
    <div>
      <DrawerContents>
        <SlideUpWrapper>
          {countries.map(country => (
            <div onClick={handleClose}>
              <Option to={`/map/${country}`}>{country}</Option>
            </div>
          ))}
          <div onClick={handleClose}>
            <Option to="/calendar">calendar</Option>
          </div>
        </SlideUpWrapper>
      </DrawerContents>
      <DrawerSecondLayer />
      <DrawerBackdrop onClick={handleClose} />
      <CloseButton onClick={handleClose}>&times;</CloseButton>
    </div>
  );
}

const SlideUpWrapper = styled.div`
  animation: fade-slide-up 0.5s ease forwards;
  opacity: 0;
  @keyframes fade-slide-up {
    0% {
      opacity: 0;
      transform: translateY(100px);
    }
    100% {
      transform: translateY(0px);
      opacity: 1;
    }
  }
`;

const DrawerContents = styled.div`
  background-color: turquoise;
  padding: 2em 2em;
  box-sizing: border-box;
  position: fixed;
  z-index: 3;
  animation: expand-contents-desktop 0.3s ease forwards;
  @media (max-width: 600px) {
    animation: expand-contents-mobile 0.3s ease forwards;
  }
  @keyframes expand-contents-mobile {
    0% {
      top: 1em;
      height: 50px;
      width: 50px;
      border-radius: 50px;
    }
    100% {
      top: 0em;
      height: calc(90vh - 250px);
      width: 100vw;
      border-radius: 0px 0px 100vh 0px;
    }
  }
  @keyframes expand-contents-desktop {
    0% {
      top: 1em;
      height: 50px;
      width: 50px;
      border-radius: 50px;
    }
    100% {
      top: 0em;
      width: 300px;
      height: calc(90vh - 250px);
      border-radius: 0px 0px 100vh 0px;
    }
  }
`;

const Option = styled(Link)`
  color: white;
  font-size: 20px;
  font-weight: bold;
  display: block;
  text-decoration: none;
  margin: 1em;
`;

const DrawerSecondLayer = styled.div`
  position: fixed;
  z-index: 2;
  animation: expand-second-layer-desktop 0.4s ease forwards;
  @media (max-width: 600px) {
    animation: expand-second-layer-mobile 0.4s ease forwards;
  }
  background-color: turquoise;
  filter: brightness(80%);
  @keyframes expand-second-layer-mobile {
    0% {
      top: 1em;
      height: 50px;
      width: 50px;
      border-radius: 50px;
    }
    100% {
      top: 0em;
      height: calc(90vh - 175px);
      width: 100vw;
      border-radius: 0px 0px 100vh 0px;
    }
  }

  @keyframes expand-second-layer-desktop {
    0% {
      top: 1em;
      height: 50px;
      width: 50px;
      border-radius: 50px;
    }
    100% {
      top: 0em;
      height: calc(90vh - 175px);
      width: 301px;
      border-radius: 0px 0px 100vh 0px;
    }
  }
`;

const DrawerBackdrop = styled.div`
  position: fixed;
  z-index: 1;
  animation: expand-backdrop 0.2s ease forwards;
  background-color: black;
  cursor: pointer;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  @keyframes expand-backdrop {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.7;
    }
  }
`;

const CloseButton = styled.div`
  position: fixed;
  z-index: 2;
  left: 50vw;
  bottom: -100px;
  transform: translateX(-50%);
  border-radius: 100px;
  background-color: turquoise;
  box-shadow: var(--shadow-1);
  font-size: 30px;
  font-weight: bold;
  height: 75px;
  width: 75px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  cursor: pointer;
  animation: slide-up 0.4s ease forwards;
  @keyframes slide-up {
    0% {
      bottom: -100px;
    }
    100% {
      bottom: 1em;
    }
  }
`;

function Tab(props) {
  return (
    <TabWrapper {...props}>
      <Line style={{ marginRight: "6px" }} />
      <Line style={{ marginLeft: "6px" }} />
    </TabWrapper>
  );
}

const TabWrapper = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 0 1em 1em 0;
  background-color: turquoise;
  box-shadow: var(--shadow-1);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
`;

const Line = styled.div`
  width: 10px;
  border: 1px solid white;
  margin: 3px 0;
`;
